import { useEffect, useMemo, useState } from "react";
import { IDropdownOption } from "@fluentui/react";
import { Entity } from "@cayo/shared/api/types/cayo-graph";
import { IScope } from "@cayo/shared/api/types/schema";
import { bindingsUtils } from "@cayo/shared/scheme/bindings";
import { endpoints } from "@cayo/shared/services/endpoints.service";
import { oClient } from "@cayo/shared/libs/oDataClient";

const useScopes = (queryTemplatePath: string, scope?: IScope) => {
  const [scopes, setScopes] = useState<IDropdownOption[] | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedScopeKey, setSelectedScopeKey] = useState("");

  useEffect(() => {
    if (!scope?.path) {
      setScopes([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    oClient(endpoints.publicUrl)
      .get("v0/" + scope?.path)
      .query()
      .then((response: Entity[]) => {
        setIsLoading(false);
        const loadedScopes = response.map<IDropdownOption>((o) => ({
          key: o.objectPath!,
          text: o.objectName!,
        }));
        setScopes(loadedScopes);

        if (loadedScopes?.length) {
          setSelectedScopeKey(loadedScopes[0].key as string);
        }
      })
      .then(() => {
        setIsLoading(false);
      });
  }, [scope?.path]);

  const queryPath = useMemo(() => {
    const model: any = {};

    if (scopes && scopes?.length > 0) {
      model.scope = { objectPath: selectedScopeKey || scopes[0].key };
    }

    const path = model.scope?.objectPath
      ? bindingsUtils.resolveExpression(model, queryTemplatePath!)?.toString()
      : queryTemplatePath;
    return path;
  }, [scopes, selectedScopeKey]);

  return {
    queryPath: scopes ? queryPath : undefined,
    selectedScopeKey,
    setSelectedScopeKey,
    isLoading,
    scopes,
  };
};

export default useScopes;
